import * as React from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "../../lib/styled";

interface ImageTextProps {
  image?: string;
  textArea: string;
  layout: "left" | "right" | "top" | "bottom";
}

const ImageTextLayout: React.FC<ImageTextProps> = (props) => {
  return (
    <Wrapper className={`image-text--wrapper align-${props.layout}`}>
      <div className="image-text--image">
        <img src={props.image} alt={props.textArea} />
      </div>
      <div className="image-text--text-area">
        <p>{ReactHtmlParser(props.textArea)}</p>
      </div>
    </Wrapper>
  );
};

export default ImageTextLayout;

const Wrapper = styled.div`
  display: flex;
  margin: 10px 0;
  flex-direction: row;

  &.align-left {
    flex-direction: row;
    .image-text--text-area {
      margin-left: 12px;
      flex: 2;
    }
  }

  &.align-right {
    flex-direction: row-reverse;
    .image-text--text-area {
      margin-right: 12px;
      flex: 2;
    }
  }

  &.align-top {
    flex-direction: column;
    .image-text--text-area {
      margin-top: 12px;
    }
  }

  &.align-bottom {
    flex-direction: column-reverse;
    .image-text--text-area {
      margin-bottom: 12px;
    }
  }

  .image-text--image {
    width: auto;
    flex: 1;
  }

  .image-text--text-area {
    line-height: 1em;
    margin: 0;
    flex: 1;
  }
`;
